import { z } from "zod/v3";

export type Option = {
	value: string;
	label: string;
};

const IdAndLabelShared = z.object({
	label: z.string(),
	value: z.string(),

	properties: z.record(z.any()).nullish(),
	metaData: z.record(z.any()).nullish(),
});

export const IdAndLabel = z.union([
	IdAndLabelShared.extend({
		id: z.string(),
		key: z.string().nullish(),
	}),
	IdAndLabelShared.extend({
		id: z.string().optional(),
		key: z.string(),
	}),
]);
export type IdAndLabel = z.infer<typeof IdAndLabel>;
